
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/trainings/[...params]",
      function () {
        return require("private-next-pages/[lang]/trainings/[...params].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/trainings/[...params]"])
      });
    }
  